import React from 'react';
import {
  Container, createStyles, Title,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import { LANGUAGES, PORTFOLIO_LINKS } from '../config/constants';
import PortfolioEntry from '../components/Portfolio/Entry';
import Fab from '../components/Fab/Fab';

const useStyles = createStyles((theme) => ({
  root: {
  },
  container: {
    [theme.fn.smallerThan('sm')]: {
      padding: 0,
    },
  },
  separator: {
    marginBlock: '16px !important',
  },
}));

const PAGE_ROUTE = '/portfolio';

export default function Portfolio() {
  const { t, i18n } = useTranslation('translation', { keyPrefix: 'portfolio' });
  const { classes, cx } = useStyles();
  const { lang } = useParams();
  const navigate = useNavigate();

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  React.useEffect(() => {
    if (lang && LANGUAGES.find((l) => l.code === lang)) {
      changeLanguage(lang);
      navigate(PAGE_ROUTE);
    }
  }, []);

  return (
    <Container className={classes.container}>
      <Title order={1} align="center">{t('title')}</Title>
      <PortfolioEntry
        id="cvonline"
        title={t('cvonline.title')}
        description={t('cvonline.description')}
        screenshot="/images/cv_online_screenshot.png"
        link={PORTFOLIO_LINKS.cvonline.link}
        youtube={PORTFOLIO_LINKS.cvonline.youtube}
      />
      <div className={cx('separator', classes.separator)} />
      <PortfolioEntry
        id="diceandroll"
        title={t('diceandroll.title')}
        description={t('diceandroll.description')}
        screenshot="/images/dice_and_roll_screenshot.png"
        link={PORTFOLIO_LINKS.diceandroll.link}
        github={PORTFOLIO_LINKS.diceandroll.github}
        youtube={PORTFOLIO_LINKS.diceandroll.youtube}
      />
      <div className={cx('separator', classes.separator)} />
      <PortfolioEntry
        id="spotivision"
        title={t('spotivision.title')}
        description={t('spotivision.description')}
        screenshot="/images/streamvision_screenshot.png"
        github={PORTFOLIO_LINKS.spotivision.github}
        youtube={PORTFOLIO_LINKS.spotivision.youtube}
      />
      <div className={cx('separator', classes.separator)} />
      <PortfolioEntry
        id="myScorewiz"
        title={t('myScorewiz.title')}
        description={t('myScorewiz.description')}
        screenshot="/images/my_scorewiz_screenshot.png"
        github={PORTFOLIO_LINKS.myScorewiz.github}
        youtube={PORTFOLIO_LINKS.myScorewiz.youtube}
      />

      <Fab pageRoute={PAGE_ROUTE} />
    </Container>
  );
}
